var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof airbnb_favorites !== "undefined") return resolve();
	__webpack_require__.l("https://t-web-renovate-actions-setup-node-digest-rodrigo-yoko-980ac0-ze.zephyrcloud.app/remoteEntry.js", (event) => {
		if(typeof airbnb_favorites !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "airbnb_favorites");
}).then(() => (airbnb_favorites));